namespace RioERP.Masters {
    export interface InvoiceCompanyForm {
        Name: Serenity.StringEditor;
        Address: Serenity.TextAreaEditor;
        GstIn: Serenity.StringEditor;
        InvoiceCode: Serenity.StringEditor;
        TaxApplicable: Serenity.EnumEditor;
        IsTaxApplicable: Serenity.BooleanEditor;
        DisableInvoiceGenration: Serenity.BooleanEditor;
        InvoiceChangeDate: Serenity.DateEditor;
        IsDefault: Serenity.BooleanEditor;
        FooterNote: Serenity.TextAreaEditor;
        Logo1: Serenity.ImageUploadEditor;
        Logo2: Serenity.ImageUploadEditor;
        StampImage: Serenity.ImageUploadEditor;
    }

    export class InvoiceCompanyForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.InvoiceCompany';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoiceCompanyForm.init)  {
                InvoiceCompanyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.EnumEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DateEditor;
                var w5 = s.ImageUploadEditor;

                Q.initFormType(InvoiceCompanyForm, [
                    'Name', w0,
                    'Address', w1,
                    'GstIn', w0,
                    'InvoiceCode', w0,
                    'TaxApplicable', w2,
                    'IsTaxApplicable', w3,
                    'DisableInvoiceGenration', w3,
                    'InvoiceChangeDate', w4,
                    'IsDefault', w3,
                    'FooterNote', w1,
                    'Logo1', w5,
                    'Logo2', w5,
                    'StampImage', w5
                ]);
            }
        }
    }
}
